import { Injectable } from '@angular/core';
import { AjaxService } from './ajax.service';
import { Observable } from 'rxjs';

@Injectable()
export class AuthenticationService {
  private $api: string = '';

  constructor(private $ajax: AjaxService) {
    this.$api = $ajax.getAPIDomain();
  }

  /**
   * 로그인
   */
  login(id:string, pw: string): Observable<any> {
    return this.$ajax.httpRequest(
        'POST',
        this.$api + 'login',
        { id, pw },
    );
  }

  /**
   * 로그아웃
   */
  logout(id: string): Observable<any> {
    return this.$ajax.httpRequest(
        'POST',
        this.$api + 'logout',
        { id },
    );
  }

  /**
   * 비밀번호 변경
   */
  changePwd(id: string, cpwd: string, npwd: string): Observable<any> {
    return this.$ajax.httpRequest(
        'POST',
        this.$api + 'change-pwd',
        { id, cpwd, npwd },
    );
  }

  /**
   * 아이디 찾기
   */
  findId(name: string, phoneEmail:string): Observable<any> {
    return this.$ajax.httpRequest(
        'GET',
        this.$api + `find-id/${name}/${phoneEmail}`,
    );
  }

  /**
   * 비밀번호 찾기
   */
  findPw(userName:string , userId:string, userPhoneNum:string): Observable<any> {
    return this.$ajax.httpRequest(
        'POST',
        this.$api + 'find-pw',
        { userName, userId, userPhoneNum },
    );
  }
}
